import React from "react";
import { Link } from "react-router-dom";
import { MdLocationOn } from "react-icons/md";
import { MdPhone } from "react-icons/md";
import { FaWhatsapp } from "react-icons/fa";
import { RiMailSendLine } from "react-icons/ri";
import { BsFacebook } from "react-icons/bs";
import { AiFillTwitterCircle } from "react-icons/ai";
import { GiRotaryPhone } from "react-icons/gi";

import "./index.css";
import Linkd from "../../assets/linkd.png";
import Insta from "../../assets/inst.png";
import Foot from "../../assets/GRF_TM.png";
import {
  isMobiledevice,
  getSavedData,
  saveLocalData,
} from "../../utils/helperFunctions";
import { api_call } from "../../utils/Network";

function Footer() {
  const [displayData, setDisplayData] = React.useState({
    contact: { description: "+917208998404/+917208998406/+917208998409" },
  });

  React.useEffect(() => {
    window.scrollTo(0, 0);
    if (getSavedData("baseData")) setDisplayData(getSavedData("baseData"));
    getData();
  }, []);

  const getData = () => {
    api_call.get(`service_list/base_detail/info/`).then((response) => {
      const [
        contact,
        landline,
        whatsapp,
        email,
        address,
        footerLogo,
        twitter,
        facebook,
        linkedin,
        instagram,
        topBannerText,
      ] = response.data.data;
      const baseData = {
        contact,
        landline,
        whatsapp,
        email,
        address,
        footerLogo,
        twitter,
        facebook,
        linkedin,
        instagram,
        topBannerText,
      };
      setDisplayData(baseData);
      saveLocalData("baseData", baseData);
    });
  };

  return (
    <div className="main_foot">
      <div className="footer_main">
        <div className="textLogo">
          <img src={Foot} alt="logofooter" className="logofooter" />
          <div className="footer_desc">
            <MdLocationOn style={{ width: "70px", marginRight: "10px" }} />
            <p className="foot_title">
              {displayData.address?.description ||
                "Unit No. 301 & 302, Laxmi The Mall, Laxmi Industrial Estate,Andheri Link Road, Andheri West, Mumbai - 400053"}
            </p>
          </div>
        </div>
        <div>
          <div className="footer_content">
            <div className="footer_details">
              <ul>
                <li className="heads-footer">Contact Us</li>
                {displayData.contact?.description?.split("/").map((c) => (
                  <li key={c} className="heads-footer">
                    <a
                      className="footer-link footer_align_center"
                      target="_blank"
                      href={`tel:${c}`}
                    >
                      <MdPhone className="footer_icons" />
                      <span className="footer_text">
                        {c.slice(0, 3)} {c.slice(3, 8)} {c.slice(8)}
                      </span>
                    </a>
                  </li>
                ))}
              </ul>
            </div>
            <div
              style={isMobiledevice() ? { marginTop: -10 } : {}}
              className="footer_details"
            >
              <ul
                style={
                  isMobiledevice() ? {} : { paddingTop: 32, paddingRight: 20 }
                }
              >
                <li className="heads-footer">
                  <a
                    className="footer-link footer_align_center"
                    target="_blank"
                    href={`tel:+91${
                      displayData.landline?.description || "02240156140"
                    }`}
                  >
                    <GiRotaryPhone className="footer_icons" />
                    <span className="footer_text">
                      {displayData.landline?.description
                        ? `${displayData.landline?.description?.slice(
                            0,
                            3
                          )} ${displayData.landline?.description?.slice(
                            3,
                            7
                          )} ${displayData.landline?.description?.slice(7)}`
                        : "022 4015 6140"}
                    </span>
                  </a>
                </li>
                <li className="heads-footer">
                  <a
                    className="footer-link footer_align_center"
                    target="_blank"
                    href={`https://api.whatsapp.com/send?phone=${
                      displayData.whatsapp?.description || "+917738398406"
                    }`}
                  >
                    <FaWhatsapp className="footer_icons" />
                    <span className="footer_text">
                      {displayData.whatsapp?.description
                        ? displayData.whatsapp?.description?.slice(0, 3) +
                          " " +
                          displayData.whatsapp?.description?.slice(3)
                        : "+91 7738398406"}
                    </span>
                  </a>
                </li>
                <li className="heads-footer">
                  <a
                    className="footer-link footer_align_center"
                    target="_blank"
                    href={`mailto:${
                      displayData.email?.description || "info@grandrf.com"
                    }`}
                  >
                    <RiMailSendLine className="footer_icons" />
                    <span className="footer_text">
                      {displayData.email?.description || "info@grandrf.com"}
                    </span>
                  </a>
                </li>
              </ul>
            </div>
            <div className="footer_details">
              <ul>
                <li className="heads-footer">
                  <Link className="footer-link" to="/about">
                    <span className="footer_text">About Us</span>
                  </Link>
                </li>
                <li className="heads-footer">
                  <Link className="footer-link" to="/cart/1/1/0">
                    <span className="footer_text">Our Services</span>
                  </Link>
                </li>
                <li className="heads-footer">
                  <Link className="footer-link" to="/testimonial">
                    <span className="footer_text">Testimonials</span>
                  </Link>
                </li>
                <li className="heads-footer">
                  <Link className="footer-link" to="/vertical">
                    <span className="footer_text">Verticals @ GRF</span>
                  </Link>
                </li>
              </ul>
            </div>
            <div className="footer_details">
              <ul>
                <Link to="/careers" className="heads-footer footer-link">
                  <span className="footer_text">GRF Career</span>
                </Link>
                <Link to="/privacy-policy" className="heads-footer footer-link">
                  <span className="footer_text">Privacy Policy</span>
                </Link>
                <Link
                  to="/terms&conditions"
                  className="heads-footer footer-link"
                >
                  <span className="footer_text">Terms & Conditions</span>
                </Link>
                <Link
                  to="/cancellation&refund-policy"
                  className="heads-footer footer-link"
                >
                  <span className="footer_text">
                    Cancellation <span className="extra_text">& Refund </span>
                    Policy
                  </span>
                </Link>
              </ul>
            </div>
          </div>
          <div className="social_icons">
            <a
              href={
                displayData.twitter?.description ||
                "https://twitter.com/resource_grand"
              }
              target="_blank"
            >
              <AiFillTwitterCircle
                style={{ color: "white", fontSize: "30px", padding: "0 10px" }}
              />
            </a>
            <a
              href={
                displayData.facebook?.description ||
                "https://www.facebook.com/Grand-Resource-Factory-108903730555474"
              }
              target="_blank"
            >
              <BsFacebook
                style={{ color: "white", fontSize: "28px", padding: "0 10px" }}
              />
            </a>
            <a
              href={
                displayData.linkedin?.description ||
                "https://www.linkedin.com/company/grand-resource-factory"
              }
              target="_blank"
            >
              <img
                src={Linkd}
                alt="Insta"
                style={{ width: "28px", padding: "0 10px" }}
              />
            </a>
            <a
              href={
                displayData.instagram?.description ||
                "https://www.instagram.com/grandresourcefactory/"
              }
              target="_blank"
            >
              <img
                src={Insta}
                alt="Insta"
                style={{ width: "28px", padding: "0 10px" }}
              />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Footer;
